<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="4">
        <v-card class="pa-2">
          <v-card-title>
            <h4>Détail de la demande</h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <b>Cabinet: </b>
            {{ this.$store.getters["Auth/get_selected_demandequitus"].nomCabinet }}
            <v-spacer class="my-1"></v-spacer>
            <b>Nom du chargé: </b>
            {{ this.$store.getters["Auth/get_selected_demandequitus"].nomPersonne }}
            <v-spacer class="my-1"></v-spacer>
            <b>E-mail: </b>
            {{ this.$store.getters["Auth/get_selected_demandequitus"].emailContact }}
            <v-spacer class="my-1"></v-spacer>
            <b>Date Demande: </b>
            {{ this.$store.getters["Auth/get_selected_demandequitus"].dateDemande }}
            <v-spacer class="my-1"></v-spacer>
            <b>Status Demande: </b>
            {{ this.$store.getters["Auth/get_selected_demandequitus"].status }}
            <v-spacer class="my-1"></v-spacer>
          </v-card-text>
        </v-card>

      </v-col>
      <v-col cols="12" md="8">
        <v-card>
          <v-card-title>
            <h4 v-if="status === 'Délivrée'">Aperçu du quitus délivré</h4>
            <h4 v-else-if="status === 'Rejetée'">Aperçu de la lettre de rejet</h4>
            <h4 v-else>En Cours de Traitement</h4>
            <v-spacer></v-spacer>
            <v-btn small v-if="status == 'Délivrée'" @click="downloadQuitus()" class="primary">
              <v-icon>mdi-download</v-icon>
              Télécharger
            </v-btn>
            <v-btn small v-if="status == 'Rejetée'" @click="downloadRejectLetter()" class="primary">
                <v-icon>mdi-download</v-icon>
                Télécharger
              </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text v-if="status == 'Délivrée'" style="height:62em !important;overflow:hidden">
            <VueDocPreview style="height:100%" v-if="this.$store.getters['Auth/get_selected_demandequitus'].extensionQuitus == 'doc' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionQuitus == 'docx' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionQuitus == 'xls' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionQuitus == 'xlsx' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionQuitus == 'XLS' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionQuitus == 'XLSX'
              " :value="this.$store.getters['Auth/get_selected_demandequitus'].fileLinkQuitus" type="office" />

            <vue-friendly-iframe v-if="this.$store.getters['Auth/get_selected_demandequitus'].extensionQuitus == 'pdf'"
              :src="this.$store.getters['Auth/get_selected_demandequitus'].fileLinkQuitus + '#toolbar=0'
              " frameborder="0" loading="lazy"></vue-friendly-iframe>
          </v-card-text>
          
          <v-card-text v-if="status == 'Rejetée'" style="height:62em !important;overflow:hidden">
            <VueDocPreview style="height:100%" v-if="this.$store.getters['Auth/get_selected_demandequitus'].extensionRejectLetter == 'doc' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionRejectLetter == 'docx' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionRejectLetter == 'xls' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionRejectLetter == 'xlsx' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionRejectLetter == 'XLS' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionRejectLetter == 'XLSX'
              " :value="this.$store.getters['Auth/get_selected_demandequitus'].fileLinkRejectLetter" type="office" />

            <vue-friendly-iframe v-if="this.$store.getters['Auth/get_selected_demandequitus'].extensionRejectLetter == 'pdf'"
              :src="this.$store.getters['Auth/get_selected_demandequitus'].fileLinkRejectLetter + '#toolbar=0'
              " frameborder="0" loading="lazy"></vue-friendly-iframe>
          </v-card-text>
          
          <v-card-text v-if="status == 'En_Cours'" style="height:62em !important;overflow:hidden">
              <h4>La demande est en cours de traitement...</h4>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VueDocPreview from "vue-doc-preview";

export default {
  components: {
    VueDocPreview
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    profile: 0,
    dialog: false,
  }),
  created() {
    this.$store.dispatch("Auth/loadDemandeQuitusById", this.id);
    let Virt = [];
    Virt = JSON.parse(localStorage.getItem("userData"));
    this.profile = Virt.profile.status;
  },
  computed: {
    status() {
      return this.$store.getters['Auth/get_selected_demandequitus'].status;
    }
  },
  methods: {
    getInit() {
      this.InitLink = this.$store.getters["Auth/get_selected_demandequitus"].file_link;
      console.log("INFOS", InitLink);
    },
    downloadQuitus() {
      const data = new FormData();
      data.append("id", this.id);
      this.$store.dispatch("Auth/downloadQuitus", data);
    },
    downloadRejectLetter() {
        const data = new FormData();
        data.append("id", this.id);
        this.$store.dispatch("Auth/downloadRejectLetterQuitus", data);
      }
  }
};
</script>
<style>
.w-62em {
  height: 62em !important;
  width: 100% !important;
}

.v-card__text {
  width: 100% !important;
}

.vue-friendly-iframe iframe {
  width: 100% !important;
  height: 62em !important;
}

h4{
  word-break: break-word
}
</style>